<template>
  <div class="badge-group position-relative">
    <slot></slot>
    <div
      v-if="isCollapsed && hasManyItems"
      @click="toggleVisibility"
      @click.prevent
      class="more-button"
    >
      <Badge :text="`+ ${overflowingItems.length}`" variant="ghost" />
    </div>
  </div>
</template>

<script>
import Badge from "./Badge";

export default {
  name: "BadgeGroup",
  components: {
    Badge,
  },
  props: {
    maxVisible: {
      type: Number,
      default: 3,
      required: false,
    },
  },
  data() {
    return {
      isCollapsed: true,
      items: this.$slots.default,
      hasManyItems: this.$slots.default ? this.$slots.default.length > this.maxVisible : false,
    };
  },
  computed: {
    overflowingItems() {
      if (this.$slots.default && this.maxVisible) {
        return this.$slots.default.slice(this.maxVisible, this.$slots.default.length);
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.hideOverflowingItems();
  },
  methods: {
    hideOverflowingItems() {
      if (this.$slots.default) {
        this.overflowingItems.forEach(item => {
          item.elm.classList.add("d-none");
        });
      }
    },
    showOverflowingItems() {
      this.items.forEach(item => {
        item.elm.classList.remove("d-none");
      });
    },
    toggleVisibility() {
      this.isCollapsed ? this.showOverflowingItems() : this.hideOverflowingItems();
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.badge-group {
  margin-left: -$spacer-1;
  margin-top: -$spacer-1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  > * {
    margin-left: $spacer-1;
    margin-top: $spacer-1;
  }
}

.more-button {
  cursor: pointer;
  z-index: $zi-lowest;

  &:hover {
    opacity: 0.7;
  }
}
</style>
